// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-scroll-table {
    overflow-x: auto;
    width: 100%;
  }
  
  .mobile-scroll-table table {
    border-collapse: collapse;
    min-width: 800px;
  }
  
  .mobile-scroll-table td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    white-space: nowrap;
  }
  
  .sort-iconm {
    /* width: 12px; */
    /* height: 12px; */
    margin-left: 4px;
  }
  `, "",{"version":3,"sources":["webpack://./src/ReferralGiven.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB","sourcesContent":[".mobile-scroll-table {\n    overflow-x: auto;\n    width: 100%;\n  }\n  \n  .mobile-scroll-table table {\n    border-collapse: collapse;\n    min-width: 800px;\n  }\n  \n  .mobile-scroll-table td {\n    border: 1px solid #ccc;\n    padding: 8px;\n    text-align: center;\n    white-space: nowrap;\n  }\n  \n  .sort-iconm {\n    /* width: 12px; */\n    /* height: 12px; */\n    margin-left: 4px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
